import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/report/journal', {
  name: 'ReportJournal',
});

routeMap.set('/report/freight', {
  name: 'ReportFreight',
  meta: {
    nav: [
      { title: '平台承担', id: 10 },
      { title: '客户承担', id: 20 },
    ],
  },
});

routeMap.set('/report/writeOff', {
  name: 'ReportWriteOff',
});